import types from "@/data/types"

const ticketParser = (type, items) => {
    switch (type) {
        case types.OSS_API:
        case types.OSS_WEB:
            return items?.map((item, index) => ({
                id: index,
                team: item.__event_id_unique?.split(/[0-9]/)[0],
                account_user: item.account_user,
                event_id: item.__event_id_unique?.replace(item.__event_id_unique?.split(/[0-9]/)[0], ''),
                event: item.event_detail.__event_description,
                alternative: item.event_detail?.__event_name,
                date: item.event_detail?.__event_date_year === '2999' ? 'TBD' : item.event_detail.__event_date_us_format,
                time: item.event_detail?.__event_date_year === '2999' ? 'TBD' : item.event_detail?.__event_time_us_format,
                timestamp: item.event_detail.__event_date_timestamp_local,
                section: item.__ticket_section,
                row: item.__ticket_row,
                seat: item.__ticket_seat,
                barcode: item.__ticket_barcode,
                additional: item.__ticket_entry_gate,
                ticket_id: item.__ticket_id_unique,
                _item: item,
                _search: JSON.stringify(item),
            }))
        case types.OSS_API_INVENTORY:
        case types.OSS_WEB_INVENTORY:
            return items?.map((item, index) => ({
                id: index,
                team: item.__event_id_unique?.split(/[0-9]/)[0],
                account_user: item.account_user,
                event_id: item.__event_id_unique?.replace(item.__event_id_unique.split(/[0-9]/)[0], ''),
                event: item.event_detail.__event_description,
                alternative: item.event_detail?.__event_name,
                date: item.event_detail?.__event_date_us_format,
                time: item.event_detail.__event_time_us_format,
                timestamp: item.event_detail.__event_date_timestamp_local,
                section: item.__ticket_section,
                row: item.__ticket_row,
                seat: item.__ticket_seat,
                _item: item,
                _search: JSON.stringify(item),
            }))
        case types.SG:
            return items?.map((item, index) => {
                // Parse date from event_datetime_local (ISO format) to match SaltQR format
                // SaltQR format: date("D n/j", ...) = "Mon 1/6", time("g:i A", ...) = "7:00 PM"
                const eventDate = item.event_datetime_local ? new Date(item.event_datetime_local) : null;
                const displayDate = eventDate ? eventDate.toLocaleDateString('en-US', { weekday: 'short', month: 'numeric', day: 'numeric' }) : '';
                const displayTime = eventDate ? eventDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }) : '';
                const displayYear = eventDate ? eventDate.getFullYear().toString() : '';

                const account_user = item.account_token || item.performer_id || '';
                let team = '';
                if (item.event_name && typeof item.event_name === 'string') {
                    const parts = item.event_name.split(' at ');
                    if (parts.length > 0 && parts[0]) {
                        team = parts[0].trim();
                    }
                }

                return {
                    id: index,
                    account_user: account_user, // No masking, matching SaltQR
                    date: displayDate, // Format: "Mon 1/6"
                    time: displayTime, // Format: "7:00 PM"
                    section: item.section || '',
                    row: item.row || '',
                    seat: item.seat_number || item.seat || '',
                    event_id: item.event_id || '',
                    team: team,
                    event: item.event_name || '',
                    year: displayYear, // Format: "2026"
                    venue: item.venue_name || '',
                    barcode: item.token || item.barcode || '', // QR column in SaltQR
                    _item: item,
                    _search: JSON.stringify(item),
                }
            })
        case types.OSS_CREDITS:
            return items?.map((item, index) => ({
                id: index,
                account_user: item.account_user,
                account_team: item.team,
                credit_amount: `${item.__account_credit_currency} ${item.__account_credit_amount}`,
                resale_credit: `${item.__resale_credit_currency} ${item.__resale_credit_amount}`,
                _item: item,
                _search: JSON.stringify(item),
            }))
        case types.BALLPARK_APP:
        case types.BALLPARK_WEB:
            return items?.map((item, index) => ({
                id: index,
                account_user: item.account_user,
                account_number: item.__ticket_qr_data.account_id,
                date: item.event_detail?.__event_date_us_format,
                time: item.event_detail?.__event_time_us_format,
                timestamp: item.event_detail.__event_date_timestamp_local,
                section: item.__ticket_section,
                row: item.__ticket_row,
                seat: item.__ticket_seat,
                event_id: item.event_detail.__event_id,
                teams: item.event_detail?.__event_name,
                alternative: "",
                year: item.event_detail.__event_date_year,
                venue: item.venue_detail.__venue_name,
                barcode: item.__ticket_barcode,
                ticket_id: item.__ticket_id_unique,
                _item: item,
                _search: JSON.stringify(item),
            }))
        case types.PACIOLAN_SCRAPE:
            return items?.map((item, index) => {
                const eventDate = item.event_date ? new Date(item.event_date) : null;
                const displayDate = eventDate ? eventDate.toLocaleDateString('en-US', { weekday: 'short', month: 'numeric', day: 'numeric' }) : '';
                const displayTime = eventDate ? eventDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }) : '';
                const displayYear = eventDate ? eventDate.getFullYear().toString() : '';

                return {
                    id: index,
                    account: `${item.account_team}:${item.account_user}`,
                    account_team: item.account_team,
                    account_user: item.account_user,
                    date: displayDate,
                    time: displayTime,
                    section: item.ticket_section,
                    row: item.ticket_row,
                    seat: item.ticket_seat,
                    event_id: item.event_id,
                    team: item.account_team,
                    event: item.event_name,
                    year: displayYear,
                    venue: item.event_venue,
                    barcode: item.ticket_barcode,
                    // Additional fields (will be hidden by default but available in DataTable)
                    event_season_name: item.event_season_name || '',
                    event_date: item.event_date,
                    ticket_id_eres: item.ticket_id_eres,
                    ticket_id_transfer: item.ticket_id_transfer,
                    ticket_id_seat: item.ticket_id_seat,
                    ticket_level: item.ticket_level,
                    ticket_is_transferable: item.ticket_is_transferable,
                    ticket_transfer_status: item.ticket_transfer_status,
                    ticket_transfer_id: item.ticket_transfer_id,
                    ticket_is_sellable: item.ticket_is_sellable,
                    ticket_is_nfc_enabled: item.ticket_is_nfc_enabled,
                    ticket_id_mta: item.ticket_id_mta,
                    _item: item,
                    _search: JSON.stringify(item),
                }
            })
        case types.SEATGEEK_SCRAPE:
            return items?.map((item, index) => {
                const eventDate = item.event_time ? new Date(item.event_time) : null;
                const displayDate = eventDate ? eventDate.toLocaleDateString('en-US', { weekday: 'short', month: 'numeric', day: 'numeric' }) : '';
                const displayTime = eventDate ? eventDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }) : '';

                const raw = item.raw || {};

                let section = item.section || raw.section_raw || '';
                let row = item.row || raw.row_raw || '';
                let seat = item.seat_number || item.seat || raw.seat_raw || '';

                // Fallback to ticket_meta if missing
                if ((!section || !row || !seat) && raw.ticket_meta && Array.isArray(raw.ticket_meta)) {
                    raw.ticket_meta.forEach((meta) => {
                        if (meta.type === 'section' && !section) section = meta.value || '';
                        if (meta.type === 'row' && !row) row = meta.value || '';
                        if (meta.type === 'seat' && !seat) seat = meta.value || '';
                    });
                }

                // Extract barcode
                let barcode = item.barcode || item.token || '';
                if (!barcode && raw.barcode) {
                    if (typeof raw.barcode === 'string') {
                        barcode = raw.barcode;
                    } else if (raw.barcode.display_value) {
                        barcode = raw.barcode.display_value;
                    } else if (raw.barcode.value) {
                        barcode = raw.barcode.value;
                    }
                }

                return {
                    id: index,
                    account: item.account_user || '',
                    account_user: item.account_user || '',
                    ticket_sid: item.ticket_sid,
                    event: item.name || item.event_name || '',
                    date: displayDate,
                    time: displayTime,
                    venue: item.venue_name || '',
                    section: section,
                    row: row,
                    seat: seat,
                    barcode: barcode,
                    event_id: item.event_id,
                    event_time: item.event_time,
                    _item: item,
                    _search: JSON.stringify(item),
                }
            })
        case types.TM_AM_SCRAPE:
            return items?.map((item, index) => ({
                id: index,
                team: item.team || '',
                account: item.account || '',
                eventid: item.eventid || '',
                eventtitle: item.eventtitle || '',
                eventtitlealt: item.eventtitlealt || '',
                year: item.year != null ? String(item.year) : '',
                date: item.date || '',
                time: item.time || '',
                venue: item.venue || '',
                section: item.section || '',
                row: item.row || '',
                seat: item.seat || '',
                barcode: item.barcode || '',
                canResale: item.canResale || '',
                additional: item.additional != null ? item.additional : (item.letter != null ? item.letter : ''),
                _item: item,
                _search: JSON.stringify(item),
            }))
        default:
            console.warn("No ticket parser for the type: ", type)
            return items
    }
}

export default ticketParser
